import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Court from '../../entities/court';
import Docket from '../../entities/docket';
import Matter from '../../entities/matter';
import CourtDeadlineRule from '../../entities/courtDeadlineRule';
export function deleteCourt(court: Court, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = court.id;}
const _work = workingSet();
store.getState().dockets.getMappingFor('courtId', court.id).filter(docketTemp => docketTemp.status !== 'D').forEach(docketTemp => {
const _docket = ((_work.get('docket:' + docketTemp.id) ?? docketTemp) as Docket).clone();
_docket.status = 'U';
_docket.addedOn = newHRTimestamp();
_docket.addedBy = getCurrentUserId();
_docket.importSource = targetImportSource;
_docket.importId = mergeId;
if (_docket.courtId === court.id) {
_docket.courtId = null;

}
_work.set('docket:' + _docket.id, _docket);
store.dispatch(Actions.DocketActions.saveDocketQueue(_docket));
});
store.getState().matters.getMappingFor('courtId', court.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.courtIds = _matter.courtIds?.filter(id => id !== court.id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().courts.getMappingFor('courtId', court.id).filter(courtTemp => courtTemp.status !== 'D').forEach(courtTemp => {
const _court = ((_work.get('court:' + courtTemp.id) ?? courtTemp) as Court).clone();
_court.status = 'U';
_court.addedOn = newHRTimestamp();
_court.addedBy = getCurrentUserId();
_court.importSource = targetImportSource;
_court.importId = mergeId;
if (_court.parentCourtId === court.id) {
_court.parentCourtId = null;

}
_work.set('court:' + _court.id, _court);
store.dispatch(Actions.CourtActions.saveCourtQueue(_court));
});
store.getState().courtDeadlineRules.getMappingFor('courtId', court.id).filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D').forEach(courtDeadlineRuleTemp => {
const _courtDeadlineRule = ((_work.get('courtDeadlineRule:' + courtDeadlineRuleTemp.id) ?? courtDeadlineRuleTemp) as CourtDeadlineRule).clone();
_courtDeadlineRule.status = 'D';
_courtDeadlineRule.addedOn = newHRTimestamp();
_courtDeadlineRule.addedBy = getCurrentUserId();
_courtDeadlineRule.importSource = targetImportSource;
_courtDeadlineRule.importId = mergeId;

_work.set('courtDeadlineRule:' + _courtDeadlineRule.id, _courtDeadlineRule);
store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
});



court.status = 'D';
court.addedOn = newHRTimestamp();
court.addedBy = getCurrentUserId();
court.importSource = targetImportSource;
court.importId = mergeId;
store.dispatch(Actions.CourtActions.removeCourtQueue(court));
}
export function replaceCourt(court: Court, replaceWith: Court, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = court.id;}
const _work = workingSet();
store.getState().dockets.getMappingFor('courtId', court.id).filter(docketTemp => docketTemp.status !== 'D').forEach(docketTemp => {
const _docket = ((_work.get('docket:' + docketTemp.id) ?? docketTemp) as Docket).clone();
_docket.status = 'U';
_docket.addedOn = newHRTimestamp();
_docket.addedBy = getCurrentUserId();
_docket.importSource = targetImportSource;
_docket.importId = mergeId;
if (_docket.courtId === court.id) {
_docket.courtId = replaceWith.id;

}
_work.set('docket:' + _docket.id, _docket);
store.dispatch(Actions.DocketActions.saveDocketQueue(_docket));
});
store.getState().matters.getMappingFor('courtId', court.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.courtIds = _matter.courtIds?.map(id => (id === court.id) ? replaceWith.id : id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().courts.getMappingFor('courtId', court.id).filter(courtTemp => courtTemp.status !== 'D').forEach(courtTemp => {
const _court = ((_work.get('court:' + courtTemp.id) ?? courtTemp) as Court).clone();
_court.status = 'U';
_court.addedOn = newHRTimestamp();
_court.addedBy = getCurrentUserId();
_court.importSource = targetImportSource;
_court.importId = mergeId;
if (_court.parentCourtId === court.id) {
_court.parentCourtId = replaceWith.id;

}
_work.set('court:' + _court.id, _court);
store.dispatch(Actions.CourtActions.saveCourtQueue(_court));
});
store.getState().courtDeadlineRules.getMappingFor('courtId', court.id).filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D').forEach(courtDeadlineRuleTemp => {
const _courtDeadlineRule = ((_work.get('courtDeadlineRule:' + courtDeadlineRuleTemp.id) ?? courtDeadlineRuleTemp) as CourtDeadlineRule).clone();
_courtDeadlineRule.status = 'U';
_courtDeadlineRule.addedOn = newHRTimestamp();
_courtDeadlineRule.addedBy = getCurrentUserId();
_courtDeadlineRule.importSource = targetImportSource;
_courtDeadlineRule.importId = mergeId;
if (_courtDeadlineRule.courtId === court.id) {
_courtDeadlineRule.courtId = replaceWith.id;

}
_work.set('courtDeadlineRule:' + _courtDeadlineRule.id, _courtDeadlineRule);
store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
});



return court;
}
export function deleteImpactCourt(court: Court) {
const impacts: string[] = [];
const state = store.getState();
const docketCourtIdImpact = state.dockets.getMappingFor('courtId', court.id).filter(docket => docket.status !== 'D');
docketCourtIdImpact.forEach(() => impacts.push('dockets'));
const matterCourtIdsImpact = state.matters.getMappingFor('courtId', court.id).filter(matter => matter.status !== 'D');
matterCourtIdsImpact.forEach(() => impacts.push('matters'));
const courtParentCourtIdImpact = state.courts.getMappingFor('courtId', court.id).filter(court => court.status !== 'D');
courtParentCourtIdImpact.forEach(() => impacts.push('courts'));
const courtDeadlineRuleCourtIdImpact = state.courtDeadlineRules.getMappingFor('courtId', court.id).filter(courtDeadlineRule => courtDeadlineRule.status !== 'D');
courtDeadlineRuleCourtIdImpact.forEach(() => impacts.push('courtDeadlineRules'));



return util.countDistinct(impacts);
}
